import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { CreateError, CreateInfo } from '../Api/ApiServerHooks';
import { useTranslation } from 'react-i18next';

interface CreateErrorsComponentProps {
    errors: CreateInfo[];
}
export default function CreateErrorsComponent(props: Readonly<CreateErrorsComponentProps>) {
    const { errors } = props;
    const [createErrors, setCreateErrors] = useState<CreateInfo[]>([]);
    const { t } = useTranslation();

    useEffect(() => {
        setCreateErrors(errors);
    }, [errors]);

    

    return (
        <Box>
            <Typography variant="h5" gutterBottom>{t('Administration.usersCreationInfo')}</Typography>
            {createErrors.length > 0 && (
                <Box>
                    {createErrors.some(p => p.error === CreateError.None) && <Box boxShadow={2} p={2} m={1}>
                        <Typography variant="h6" gutterBottom>{t('Administration.createdUsers')}</Typography>
                        <List>
                            {createErrors.filter(p => p.error === CreateError.None).map((error, index) => (
                                <ListItem key={'none_' + index}>
                                    <Box display="flex" gap={2} width="100%">
                                        <ListItemText primary={error.firstName + ' ' + error.lastName} />
                                        <ListItemText primary={error.email} />
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>}
                </Box>
            )}
            {createErrors.length > 0 && (
                <Box>
                    {createErrors.some(p => p.error === CreateError.RoleNotFound) && <Box boxShadow={2} p={2} m={1}>
                        <Typography variant="h6" gutterBottom>{t('Administration.createdUsersRoleNotFound')}</Typography>
                        <List>
                            {createErrors.filter(p => p.error === CreateError.RoleNotFound).map((error, index) => (
                                <ListItem key={'notRole_' + index}>
                                    <Box display="flex" gap={2} width="100%">
                                        <ListItemText primary={error.firstName + ' ' + error.lastName} />
                                        <ListItemText primary={error.email} />
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>}
                </Box>
            )}
            {createErrors.length > 0 && (
                <Box>
                    {createErrors.some(p => p.error === CreateError.InvalidEmail) && <Box boxShadow={2} p={2} m={1}>
                        <Typography variant="h6" gutterBottom>{t('Administration.invalidemailusers')}</Typography>
                        <List>
                            {createErrors.filter(p => p.error === CreateError.InvalidEmail).map((error, index) => (
                                <ListItem key={'mail_' + index}>
                                    <Box display="flex" gap={2} width="100%">
                                        <ListItemText primary={error.firstName + ' ' + error.lastName} />
                                        <ListItemText primary={error.email} />
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>}
                </Box>
            )}
            {createErrors.length > 0 && (
                <Box>
                    {createErrors.some(p => p.error === CreateError.UserAlreadyExists) && <Box boxShadow={2} p={2} m={1}>
                        <Typography variant="h6" gutterBottom>{t('Administration.alreadyExistingUsers')}</Typography>
                        <List>
                            {createErrors.filter(p => p.error === CreateError.UserAlreadyExists).map((error, index) => (
                                <ListItem key={'already_' + index}>
                                    <Box display="flex" gap={2} width="100%">
                                        <ListItemText primary={error.firstName + ' ' + error.lastName} />
                                        <ListItemText primary={error.email} />
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>}
                </Box>
            )}
            {createErrors.length > 0 && (
                <Box>
                    {createErrors.some(p => p.error === CreateError.UnknownError) && <Box boxShadow={2} p={2} m={1}>
                        <Typography variant="h6" gutterBottom>{t('Administration.unknownErrorUsers')}</Typography>
                        <List>
                            {createErrors.filter(p => p.error === CreateError.UnknownError).map((error, index) => (
                                <ListItem key={'error_' + index}>
                                    <Box display="flex" gap={2} width="100%">
                                        <ListItemText primary={error.firstName + ' ' + error.lastName} />
                                        <ListItemText primary={error.email} />
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>}
                </Box>
            )}
        </Box>
    )
}
